<template lang="pug">
b-modal#editAiAssistant(
  ref="editAiAssistant"
  :title="$t('ui.combine.edit_ai_assistant')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row
      .col-12
        ul#editorTab.nav.nav-tabs(role='tablist')
          li.nav-item
            a#enSlideEdit-tab.nav-link(data-toggle='tab' href='#enSlideEdit-content' role='tab' aria-controls='enSlideEdit' aria-selected='false' @click="setTab('en')" :class="activeTab == 'en' ? 'active' : ''") {{ $t("ui.en") }}
          li.nav-item
            a#cnSlideEdit-tab.nav-link(data-toggle='tab' href='#cnSlideEdit-content' role='tab' aria-controls='cnSlideEdit' aria-selected='false' @click="setTab('cn')" :class="activeTab == 'cn' ? 'active' : ''") {{ $t("ui.cn") }}
          li.nav-item
            a#localSlideEdit-tab.nav-link(data-toggle='tab' href='#localSlideEdit-content' role='tab' aria-controls='localSlideEdit' aria-selected='false' @click="setTab('local')" :class="activeTab == 'local' ? 'active' : ''") {{ $t("ui.local") }}

        #editorcontent.tab-content.tab-bordered
          #enSlideEdit-content.tab-pane(:class="activeTab == 'en' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='enSlideEdit-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.name')").mb-0
                DebounceInput(
                  size="sm"
                  ref="en_name"
                  type="text"
                  :dirty="$v.en_name.$dirty"
                  :error="$v.en_name.$error"
                  v-model.trim.lazy="$v.en_name.$model"
                  :disabled="loading"
                )
                ValidateResult(:value="$v.en_name" :name="$t('ui.en_name')")
              b-form-group.w-100.mb-0
                label {{ $t('ui.description') }}
                DebounceInput(
                  size="sm"
                  ref="en_desc"
                  type="text"
                  v-model="en_desc"
                  :disabled="loading"
                )

          #cnSlideEdit-content.tab-pane(:class="activeTab == 'cn' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='cnSlideEdit-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.name')").mb-0
                DebounceInput(
                  size="sm"
                  ref="cn_name"
                  type="text"
                  v-model="cn_name"
                  :disabled="loading"
                )
              b-form-group.w-100.mb-0
                label {{ $t('ui.description') }}
                DebounceInput(
                  size="sm"
                  ref="cn_desc"
                  type="text"
                  v-model="cn_desc"
                  :disabled="loading"
                )

          #localSlideEdit-content.tab-pane(:class="activeTab == 'local' ? 'active show' : 'fade'" role='tabpanel' aria-labelledby='localSlideEdit-tab')
            div.d-flex.flex-wrap
              b-form-group.w-100(:label="$t('ui.name')").mb-0
                DebounceInput(
                  size="sm"
                  ref="local_name"
                  type="text"
                  v-model="local_name"
                  :disabled="loading"
                )
              b-form-group.w-100.mb-0
                label {{ $t('ui.description') }}
                DebounceInput(
                  size="sm"
                  ref="local_desc"
                  type="text"
                  v-model="local_desc"
                  :disabled="loading"
                )

    .alert.alert-warning.p-1.mb-2.w-100.mt-3 *{{ $t("message.banner_size_tooltips", { size: '40px x 40px' }) }}
    b-form-group.w-100(:label="$t('ui.large_image')").mb-0
      b-form-file(
        :dirty="$v.img_large.$dirty"
        :error="$v.img_large.$error"
        v-model.trim.lazy="$v.img_large.$model"
        ref="file"
        accept="image/jpeg, image/png, image/jpg"
        @change="onSelectImgLarge"
        v-if="imgLargeSrc == null"
      )
      small.form-text.text-muted {{ $t('message.tooltips_upload_size') }}
      ValidateResult(:value="$v.img_large" :name="$t('ui.large_image')")
      SubmitButton(
        :loading="loading"
        icon="fa fa-times"
        :text="$t('ui.remove')"
        type="button"
        @click="removeLargeImage()"
        variant="danger"
        size="sm"
        v-if="imgLargeSrc != null"
        )
      template(v-if="imgLargeSrc != null")
        br
        b-img.w-50.h-50(:src="imgLargeSrc")
    .alert.alert-warning.p-1.mb-2.w-100.mt-3 *{{ $t("message.banner_size_tooltips", { size: '28px x 28px' }) }}
    b-form-group.w-100(:label="$t('ui.small_image')").mb-0
      b-form-file(
        :dirty="$v.img_small.$dirty"
        :error="$v.img_small.$error"
        v-model.trim.lazy="$v.img_small.$model"
        ref="file"
        accept="image/jpeg, image/png, image/jpg"
        @change="onSelectImgSmall"
        v-if="imgSmallSrc == null"
      )
      small.form-text.text-muted {{ $t('message.tooltips_upload_size') }}
      ValidateResult(:value="$v.img_small" :name="$t('ui.small_image')")
      SubmitButton(
        :loading="loading"
        icon="fa fa-times"
        :text="$t('ui.remove')"
        type="button"
        @click="removeSmallImage()"
        variant="danger"
        size="sm"
        v-if="imgSmallSrc != null"
        )
      template(v-if="imgSmallSrc != null")
        br
        b-img.w-50.h-50(:src="imgSmallSrc")

    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import { VueEditor } from "vue2-editor";
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1048576);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VueEditor,
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      img_small: null,
      img_url_small: "",
      imgSmallSrc: null,
      imgSmallName: "",
      img_large: null,
      img_url_large: "",
      imgLargeSrc: null,
      imgLargeName: "",
      en_name: "",
      en_desc: "",
      cn_name: "",
      cn_desc: "",
      local_name: "",
      local_desc: "",
      activeTab: "en"
    };
  },
  computed: {
    imgSize() {
      return config.bannerDimension;
    },
    themeCode() {
      return this.$store.getters.selectedTheme;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    en_name: {
      required
    },
    img_small: {
      fileSizeValidation
    },
    img_large: {
      fileSizeValidation
    },
  },
  watch: {
    img_small(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgSmallSrc = value;
            })
            .catch(() => {
              this.imgSmallSrc = null;
            });
        } else {
          this.imgSmallSrc = null;
        }
      }
    },
    img_large(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.imgLargeSrc = value;
            })
            .catch(() => {
              this.imgLargeSrc = null;
            });
        } else {
          this.imgLargeSrc = null;
        }
      }
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeSmallImage() {
      this.img_small = null
      this.img_url_small = ""
      this.imgSmallSrc = null
      this.imgSmallName = ""
    },
    removeLargeImage() {
      this.img_large = null
      this.img_url_large = ""
      this.imgLargeSrc = null
      this.imgLargeName = ""
    },
    onSelectImgSmall(evt) {
      if(evt.target.files.length > 0){
        this.imgSmallName = evt.target.files[0].name;
      }else{
        return
      }
    },
    onSelectImgLarge(evt) {
      if(evt.target.files.length > 0){
        this.imgLargeName = evt.target.files[0].name;
      }else{
        return
      }
    },

    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.aiAssistantEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        img_url_large: this.img_url_large,
        img_url_small: this.img_url_small,
        en_name: this.en_name,
        en_desc: this.en_desc,
        cn_name: this.cn_name,
        cn_desc: this.cn_desc,
        local_name: this.local_name,
        local_desc: this.local_desc
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editAiAssistant.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_ai_assistant", this.feedback.status);
                this.$refs.editAiAssistant.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadImageSmall() {
      if (this.imgSmallName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.img_small);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.img_url_small = response.data.file.filename;
            }
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadImageLarge() {
      if (this.imgLargeName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.img_large);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.img_url_large = response.data.file.filename;
            }
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadImageSmall();
      const p2 = this.uploadImageLarge();
      const someResult = await p1;
      const anotherResult = await p2;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.activeTab = 'en';
    },
    shown: function() {
      this.en_name = this.item.en_name;
      this.en_desc = this.item.en_desc;
      this.img_url_small = this.item.img_url_small;
      this.imgSmallSrc = this.item.img_url_small != null ? this.getImgPath(this.item.img_url_small) : null;
      this.img_url_large = this.item.img_url_large;
      this.imgLargeSrc = this.item.img_url_large != null ? this.getImgPath(this.item.img_url_large) : null;
      this.cn_name = this.item.cn_name;
      this.cn_desc = this.item.cn_desc;
      this.local_name = this.item.local_name;
      this.local_desc = this.item.local_desc;
      this.imgSmallName = ""
      this.imgLargeName = ""
      this.$v.$reset();
    },
    getImgPath: function(img) {
      const url = URL.parse(img);
      if (url != null && url.protocol === "https:") {
        return img
      } else {
        return config.viewImageUrl + img
      }
    },
  }
};
</script>
